import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createBlock as _createBlock, Fragment as _Fragment } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "fade-op" }, {
      default: _withCtx(() => [
        ($props.isModalOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "modal-background",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($props.closeModal && $props.closeModal(...args)))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    ($props.type === 'empty')
      ? (_openBlock(), _createBlock(_Transition, {
          key: 0,
          name: "slide-fade-y-50"
        }, {
          default: _withCtx(() => [
            ($props.isModalOpen)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "empty box",
                  style: _normalizeStyle({ zIndex: `${$props.zIndex}`, background: `${$props.background}` })
                }, [
                  _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                ], 4))
              : _createCommentVNode("", true)
          ]),
          _: 3
        }))
      : _createCommentVNode("", true),
    ($props.type === 'popup')
      ? (_openBlock(), _createBlock(_Transition, {
          key: 1,
          name: "slide-fade-y-50"
        }, {
          default: _withCtx(() => [
            ($props.isModalOpen)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "modal box",
                  style: _normalizeStyle({ zIndex: `${$props.zIndex}`, background: `${$props.background}` })
                }, [
                  _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                ], 4))
              : _createCommentVNode("", true)
          ]),
          _: 3
        }))
      : _createCommentVNode("", true),
    ($props.type === 'bottom-sheet')
      ? (_openBlock(), _createBlock(_Transition, {
          key: 2,
          name: "slide-bottom"
        }, {
          default: _withCtx(() => [
            ($props.isModalOpen)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "bottom-sheet box",
                  style: _normalizeStyle({ zIndex: `${$props.zIndex}` })
                }, [
                  _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                ], 4))
              : _createCommentVNode("", true)
          ]),
          _: 3
        }))
      : _createCommentVNode("", true),
    ($props.type === 'card')
      ? (_openBlock(), _createBlock(_Transition, {
          key: 3,
          name: "slide-in-out"
        }, {
          default: _withCtx(() => [
            ($props.isModalOpen)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "card box",
                  style: _normalizeStyle({ zIndex: `${$props.zIndex}` })
                }, [
                  _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                ], 4))
              : _createCommentVNode("", true)
          ]),
          _: 3
        }))
      : _createCommentVNode("", true)
  ], 64))
}